import { render, staticRenderFns } from "./AdiMagazzinoPageList.vue?vue&type=template&id=1aa3f262"
import script from "./AdiMagazzinoPageList.vue?vue&type=script&lang=js"
export * from "./AdiMagazzinoPageList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports